import { capitalize } from 'lodash'

import { Repayment, RepaymentPolicyStatus } from '../../models/repayments'

export function getPolicyHeader(policy: Repayment) {
  const tags = capitalize(
    policy.repayment_details.vendor_program_tags.join(', ').toLowerCase().replace(/_/gi, ' ')
  )

  return policy ? `${tags} (${policy.repayment_details.policy_type})` : '...'
}

export function getPolicyStatus(policy: Repayment) {
  return policy?.repayment_details.policy_status ?? RepaymentPolicyStatus.DRAFT
}
